module.exports = __webpack_public_path__ + "static/untitled-sans-web-regular-fe480377cc32b14beedd983e7a66e538.woff2";